import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import {actionTypes, ControlRiskType, taskBuildMilestoneIds} from '../../../src/util/uiconstants';
import _ from 'lodash';

export default function accountsReducerAccountList(state = initialstate.accountList, action) {
	switch (action.type) {
		case types.GET_ACCOUNT_LIST:
			if (action.response) {
				if (!_.isEmpty(action.payload)) {
					let data = filterAccountsBasedOnValidation(action.payload, action.response.data);
					return {...action.response, data};
				}
				return action.response || state;
			}
			break;

		case types.UPDATE_ACCOUNT_WCGW_CONTROL_RELATION:
			if (action.payload) {
				let wcgwIdToBeUpdated = action.payload.controlData.wcgwId;
				let controlToBeUpdated = action.payload.controlData;
				let newState = _.cloneDeep(state);
				_.forEach(newState.data, (account) => {
					_.forEach(account.assertions, (assertion) => {
						_.forEach(assertion.wcgWs, (wcgW) => {
							if (wcgW.id === wcgwIdToBeUpdated) {
								if (!action.payload.isRelate) {
									let updatedList = wcgW.controls.filter((c) => c.id !== controlToBeUpdated.id);
									wcgW.controls = [...updatedList];
								} else {
									wcgW.controls = [...wcgW.controls, controlToBeUpdated];
								}
							}
						});
					});
				});
				return newState;
			}
			break;

		case types.UPDATE_HAS_CONTROL_TESTING:
			if (action.response?.id) {
				let newState = _.cloneDeep(state);
				_.forEach(newState.data, (account) => {
					_.forEach(account.assertions, (assertion) => {
						_.forEach(assertion.wcgWs, (wcgW) => {
							_.forEach(wcgW.controls, (control) => {
								if (control.id === action.response.id) {
									control.hasControlTesting = action.response.hasControlTesting;
								}
							});
						});
					});
				});
				return newState;
			}
			return state;

		// currently we are using for accept, reject and deleted osp, please don't use for any other cases
		case types.REFRESH_TASK_IN_ACCOUNT:
			if (action.taskAttributes) {
				const task = mapTaskAttributes(action.taskAttributes);
				const accounts = state.data;
				const account = accounts.find((account) => account.id === action.taskAttributes.accountID);
				if (account) {
					let tasks = [task];
					if (!action.isForRemove) {
						// this is for accepted and rejected task
						tasks = account.assertionTasks
							.filter((assertionTask) => assertionTask.taskId === task.taskId)
							.map((x) => {
								const mappedTask = mapTaskAttributes(x);
								mappedTask.isRejected = task.isRejected;
								if (task.isRejected) {
									mappedTask.additionalInfo = task.additionalInfo;
								}
								return mappedTask;
							});
					}
					const updatedAssertionTasks = action.isForRemove
						? account.assertionTasks.filter((assertionTask) => assertionTask.taskId !== task.taskId)
						: account.assertionTasks.map((assertionTask) =>
								assertionTask.taskId === task.taskId
									? tasks.find((x) => x.assertionID === assertionTask.assertionID)
									: assertionTask
						  );

					const updatedAccountTasks = action.isForRemove
						? account.accountTasks.filter((accountTask) => accountTask.taskId !== task.taskId)
						: account.accountTasks.map((accountTask) => (accountTask.taskId === task.taskId ? task : accountTask));
					return {
						...state,
						data: state.data.map((account) => {
							if (account.id === action.taskAttributes.accountID) {
								return {
									...account,
									assertionTasks: updatedAssertionTasks,
									accountTasks: updatedAccountTasks
								};
							}
							return account;
						})
					};
				}
			}
			break;
		case types.UPDATE_ASSERTION_IR_CR:
			if (action.response) {
				let newState = _.cloneDeep(state);

				let accountindex = newState?.data?.findIndex((account) => account.id === action.response.accountID);
				if (accountindex > -1 && newState?.data[accountindex] && newState?.data[accountindex].assertions.length > 0) {
					let assertionindex = newState?.data[accountindex].assertions.findIndex(
						(assertion) => assertion.id === action.response.id
					);
					if (assertionindex > -1) {
						let assertion = newState?.data[accountindex].assertions[assertionindex];
						assertion.controlRiskTypeId = action.response.controlRiskTypeId;
						assertion.inherentRiskTypeId = action.response.inherentRiskTypeId;
						assertion.craValue = action.response.craValue;
					}
				}

				return newState || state;
			}
			break;
		case types.GET_ACCOUNT_LIST_BY_ID:
			if (action.response) {
				let newData = [];
				let tempData = _.cloneDeep(state.data);

				tempData.forEach((x) => newData.push(x.id === action.accountId ? action.response : x));

				return {
					pages: state.pages,
					data: newData
				};
			}
			break;
		case types.REFRESH_TASK_ASSERTION:
			if (action.taskAssertions) {
				// Clone the data array to avoid mutating the original state
				let updatedAccounts = _.cloneDeep(state.data);
				let actionType = action.actiontype;
				let accountIndex = updatedAccounts.findIndex((account) => account.id === action.taskAssertions.accountID);
				if (accountIndex !== -1) {
					// Clone the assertionTasks array to avoid mutating the original state
					let updatedAssertionTasks = [...updatedAccounts[accountIndex].assertionTasks];
					if (actionType === actionTypes.create) {
						// Add the new taskAssertions object to the cloned array
						updatedAssertionTasks.push(action.taskAssertions);
					} else if (actionType === actionTypes.delete) {
						// Find the index of the task to delete in the cloned array
						let taskIndex = updatedAssertionTasks.findIndex(
							(task) =>
								task.taskId === action.taskAssertions.taskId &&
								task.assertionID === action.taskAssertions.assertionID &&
								task.accountID === action.taskAssertions.accountID &&
								task.knowledgeAssertionID === action.taskAssertions.knowledgeAssertionID &&
								task.taskTypeId === action.taskAssertions.taskTypeId
						);
						// Remove the task from the cloned array if it exists
						if (taskIndex !== -1) {
							updatedAssertionTasks.splice(taskIndex, 1);
						}
					}
					// Update the assertionTasks for the specific account in the cloned data array
					updatedAccounts[accountIndex] = {
						...updatedAccounts[accountIndex],
						assertionTasks: updatedAssertionTasks
					};
				}
				// Return the new state with the updated data array
				return {
					...state,
					data: updatedAccounts
				};
			}
			break;
		default:
			return state;
	}
}

const mapTaskAttributes = (taskAttributes) => {
	return {
		accountID: taskAttributes.accountID,
		assertionID: taskAttributes.assertionID,
		taskId: taskAttributes.taskId,
		additionalInfo: taskAttributes.additionalInfo,
		isRejected: taskAttributes.isRejected,
		id: taskAttributes.taskId,
		knowledgeAssertionID: taskAttributes.knowledgeAssertionID,
		isEPSignoffRequired: taskAttributes.isEPSignoffRequired,
		isEPSignoffUserRequired: taskAttributes.isEPSignoffUserRequired,
		isEQRSignoffRequired: taskAttributes.isEQRSignoffRequired,
		isEQRSignoffUserRequired: taskAttributes.isEQRSignoffUserRequired,
		taskStatusId: taskAttributes.taskStatusId,
		taskNamePrefix: taskAttributes.taskNamePrefix,
		taskName: taskAttributes.taskName,
		knowledgeTaskTitle: taskAttributes.knowledgeTaskTitle,
		taskNameSuffix: taskAttributes.taskNameSuffix,
		taskTypeId: taskAttributes.taskTypeId,
		taskDisplayName: taskAttributes.taskDisplayName
	};
};

const filterAccountsBasedOnValidation = (payload, accounts) => {
	let filteredAccounts = [];
	if (payload.buildStep === taskBuildMilestoneIds.WCGWAssertion) {
		/* Filter out accounts that do NOT meet any of the 3 validation requirements:
		 * 1. Control risk assessment = Rely and no WCGWs are related to the assertion.
		 * 2. Control risk assessment = Rely and one or more related WCGWs have no related controls.
		 * 3. Control risk assessment = Rely and one or more related WCGWs have no related controls selected for testing.
		 * Always show the account, but only show assertions that meet the above requirements.
		 * Show the controls for these assertions.
		 */
		_.forEach(accounts, (account) => {
			let tempAccount = {...account};
			//filter out all assertions that are not rely
			tempAccount.assertions = tempAccount.assertions
				.filter((c) => c.controlRiskTypeId === ControlRiskType.Rely)
				.filter(
					(c) =>
						_.isEmpty(c.wcgWs) || // c.wcgWs?.length === 0 ||
						c.wcgWs?.find((w) => _.isEmpty(w.controls) || w.controls?.filter((wc) => !wc.hasControlTesting).length > 0)
				)
				.filter((c) => c.controlRiskTypeId === ControlRiskType.Rely);

			//filter out all assertions that have wcgws with testing controls (everything else will pass the other validations)
			tempAccount.assertions = tempAccount.assertions.filter((assertion) => {
				if (_.isEmpty(assertion.wcgWs)) {
					return true; //fails validation 1;
				} else if (
					assertion.wcgWs.filter(
						(w) => _.isEmpty(w.controls) || w.controls.filter((c) => c.hasControlTesting).length == 0
					).length > 0
				) {
					return true; //fails validation 2 and 3 (if there are no controls, then there is no testing control);
				} else {
					return false; //passes all validations
				}
			});
			tempAccount.assertions = tempAccount.assertions.map((assertion) => {
				let wcgws = assertion.wcgWs;
				assertion.wcgWs = wcgws.filter(
					(w) => _.isEmpty(w.controls) || w.controls.filter((c) => c.hasControlTesting).length == 0
				);
				return assertion;
			});
			if (!(tempAccount.assertions.length == 0 && account.assertions.length != 0)) {
				filteredAccounts.push(tempAccount);
			}
		});
	} else {
		// Filter out assertions that have a complete CRA (craValue is not empty) when toggle is on.
		_.forEach(accounts, (account) => {
			if (account.assertions.length == 0) {
				filteredAccounts.push(account);
			} else {
				account.assertions = account.assertions.filter((assertion) => _.isEmpty(assertion.craValue));
				if (account.assertions.length > 0) {
					filteredAccounts.push(account);
				}
			}
		});
	}
	return filteredAccounts;
};
